module.exports = __webpack_public_path__ + "img/gtsdschool.4a8cb8d3.png";